module.exports = __webpack_public_path__ + "assets/img/driver-active-btn-155d7878.png";